export default "__VITE_ASSET__s_X0lxp$__"